// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {forOwn, now, includes} from 'lodash';

// Redux Actions
import {authenticate, clearError, logout} from '../actions/auth-actions';

const withAuth = (WrappedComponent) => {
    class WithAuth extends Component {
        getComponentProps() {
            const {scope} = this.props;

            return {
                isAdmin: this.isAdmin,
                isLoggedIn: this.isLoggedIn,
                isServiceAdmin: this.isServiceAdmin,
                scope,
            };
        }

        isAdmin = () => {
            const {scope} = this.props;

            return includes(scope, 'admin');
        };

        isLoggedIn = () => {
            const {accessToken, ttl} = this.props;

            return accessToken && now() < ttl;
        };

        isServiceAdmin = () => {
            const {scope: scopeProp} = this.props;
            let isServiceAdmin = this.isAdmin();

            if (!isServiceAdmin) {
                forOwn(scopeProp, (scope) => {
                    if (includes(scope, '_admin')) {
                        isServiceAdmin = true;

                        return false;
                    }
                });
            }

            return isServiceAdmin;
        };

        render() {
            return <WrappedComponent {...this.props} {...this.getComponentProps()} />;
        }
    }

    WithAuth.propTypes = {
        accessToken: PropTypes.string,
        className: PropTypes.string,
        scope: PropTypes.array,
        ttl: PropTypes.number,
    };

    WithAuth.displayName = `WithAuth(${getDisplayName(WrappedComponent)})`;

    const mapStateToProps = (state) => ({...state.auth});

    const mapDispatchToProps = {
        authenticate,
        clearError,
        logout,
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithAuth);
};

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withAuth;
